// File: src/pages/Trader/OrdersAndWithdrawals/Settlements/components/Content/Content.tsx
import React from 'react';
import { useRecoilState } from 'recoil';
import { defaultIsMobile } from '../../../../../../utils/states/isMobile.state';

import SettlementsBlocks from './components/Blocks/SettlementsBlocks';
import SettlementsTable from './components/Table/SettlementsTable';
import { FilterValues } from '../CustomFilterModal/CustomFilterModal';

type Props = {
  filter?: FilterValues | null;
};

export const Content: React.FC<Props> = ({ filter }) => {
  const [version] = useRecoilState(defaultIsMobile);
  const isMobile = version.isMobile;

  return (
    <div>
      {isMobile ? (
        <SettlementsBlocks filter={filter} />
      ) : (
        <SettlementsTable filter={filter} />
      )}
    </div>
  );
};

export default Content;
